import './App.css';
import React from 'react';
import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Team from './Pages/Team';
import Events from './Pages/Events';
import EventDetails from './Pages/EventDetails';

function App(props) {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/team" element={<Team />} />
      <Route path="/events" element={<Events db={props.db}/>}/>
      <Route path="/events/:slug" element={<EventDetails db={props.db}/>} />
    </Routes>
  );
}

export default App;
